<template>

<div>
  <div class="row">
      <div class="form-check form-check-inline">
      <input @change="$emit('update',stock)" class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="1" v-model="stock"  checked>
      <label class="form-check-label" for="inlineRadio1">STOCK maggiore di zero</label>
    </div>
    <div class="form-check form-check-inline">
      <input @change="$emit('update',stock)" class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value = "2" v-model="stock">
      <label class="form-check-label" for="inlineRadio2">STOCK uguale a zero</label>
    </div>
    </div>    
</div>

</template>
<script>

export default {
    
 data () {
    return {
        stock           : 1
    }
  },
  computed: {

  },
mounted()
{

},  
created()
{
  
},
methods :
{
    
}

}

</script>
<style scoped>
.form-check-label{
  cursor:pointer
}
</style>